export function parseDp(raw) {
  const s = String(raw || '').trim();
  const stripped = s.startsWith('dp:') ? s.slice(3) : s;
  const [action, ...rest] = stripped.split('&');
  const params = {};
  for (const part of rest) {
    const eq = part.indexOf('=');
    if (eq < 0) {
      params[part] = true;
      continue;
    }
    params[part.slice(0, eq)] = decodeURIComponent(part.slice(eq + 1));
  }
  return { action, params };
}

export const GF_SECTIONS = {
  gf: 'home',
  gf_missions: 'missions',
  gf_levels: 'levels',
  gf_board: 'board',
  gf_store: 'store',
  gf_activity: 'activity',
  gf_change_nickname: 'home',
  gf_change_avatar: 'home',
};
